export default __webpack_public_path__ + "static/media/m1.74e7d6c9.png";